import React, { useEffect, useState } from "react";
import axios from "axios";
import '../assets/styles/tool.css';
import config from "../config";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import Addtool from '../assets/Francias/addtool.svg';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import no_ucdata from '../assets/images/no_ucdata.png';

function Tools() {
    const [addtoolopen, setAddtoolopen] = useState(false);
    const handelopentool = () => { setAddtoolopen(true); };
    const handelclosetool = () => { setAddtoolopen(false); };
    const [tools, setTools] = useState([]);
    const [custTools, setCustTools] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedOption, setSelectedOption] = useState("");

    const [formData, setFormData] = useState({
        label: '',
        description: '',
        camera_resolution: '',
        system_requirement: '',
        camera_position: '',
        installation_guide: '',
        code: "",
    });

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    useEffect(() => {
        setSelectedOption("Standard");
    }, []);

    const filteredTools = tools.filter((tool) =>
        tool.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const filteredCustTools = custTools.filter((tool) =>
        tool.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const fetchTools = async () => {
        try {
            const response = await axios.get(`${config.apiBaseUrl}/admin/gettools`);
            setTools(response.data.data);
            setCustTools(response.data.customizedTools);
        } catch (err) {
            console.error("Error fetching tools:", err);
            toast("Failed to fetch tools. Please try again later.");
        }
    };

    useEffect(() => {
        fetchTools();
        setFormData({
            label: '',
            description: '',
            camera_resolution: '',
            system_requirement: '',
            camera_position: '',
            installation_guide: '',
            code: "",
        });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleCustSubmit = async () => {
        try {
            const response = await axios.post(`${config.apiBaseUrl}/admin/addcustusecase`, formData);
            toast.success('Usecase added successfully', response);
            setTimeout(() => {
                handelclosetool();
                fetchTools();
            }, 2000);
        } catch (err) {
            console.error('Error adding usecase:', err);
            toast.error('Failed to add usecase. Please try again.');
        }
    };

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${config.apiBaseUrl}/admin/addusecase`, formData);
            toast.success('Usecase added successfully', response);
            setTimeout(() => {
                handelclosetool();
                fetchTools();
            }, 2000);
        } catch (err) {
            console.error('Error adding usecase:', err);
            toast.error('Failed to add usecase. Please try again.');
        }
    };

    // const handleEdit = (tool) => {
    //     setFormData({
    //           id: tool.id, 
    //         label: tool.label,
    //         description: tool.description,
    //         camera_resolution: tool.camera_resolution,
    //         system_requirement: tool.system_requirement,
    //         camera_position: tool.camera_position,
    //         installation_guide: tool.installation_guide
    //     });
    //     setAddtoolopen(true);
    // };

    const handleEditSubmit = async (id) => {
        try {
            await axios.put(`${config.apiBaseUrl}/admin/editusecase/${id}`, formData);
            toast.success('Usecase updated successfully');
            fetchTools();
        } catch (err) {
            console.error('Error updating usecase:', err);
            toast.error('Failed to update usecase. Please try again.');
        }
    };

    // const handleDelete = async (id) => {
    //     const confirmDelete = window.confirm("Are you sure you want to delete this usecase?");
    //     if (!confirmDelete) {
    //         return;
    //     }

    //     try {
    //         await axios.delete(`${config.apiBaseUrl}/admin/usecasedelete/${id}`);
    //         toast.success('Usecase deleted successfully');
    //         fetchTools();
    //     } catch (err) {
    //         console.error('Error deleting usecase:', err);
    //         toast.error('Failed to delete usecase. Please try again.');
    //     }
    // };

    return (
        <div className='tool-cm'>
            <ToastContainer />
            <div className='row w-100 h-100'>
                <div className="col-12 d-flex flex-column-tl">
                    <div className='col-12  col-lg-5 col-full'>
                        <div className="search-bar col-10">
                            <FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} />
                            <input
                                type="search"
                                placeholder="Search tool"
                                aria-label="Search"
                                className='search-bar-input'
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    <div className="col-lg-7  col-12 align-items-end col-full margin-left-tl button-cm">
                        <div className='d-flex gap-2 justify-start-tl'>
                            <div className="d-flex gap-3">
                                {["Standard", "Customized"].map((option) => (
                                    <label key={option} className="custom-radio">
                                        <input
                                            type="radio"
                                            name="selection"
                                            value={option}
                                            checked={selectedOption === option}
                                            onChange={(e) => setSelectedOption(e.target.value)}
                                        />
                                        <span className="checkmark"></span>
                                        {option}
                                    </label>
                                ))}
                            </div>

                            <button type="submit" title='Add camera' onClick={handelopentool} className="display-tool-full btn mt-0 btn-secondary add-cam-cm" >
                                <img src={Addtool} alt="img tool" className='toolimg' /> Add new tool
                            </button>
                            <button type="submit" title='Add camera' onClick={handelopentool} className="display-tool-hf btn mt-0 btn-secondary add-cam-cm" >
                                <img src={Addtool} alt="img tool" className='toolimg' /> Add
                            </button>
                        </div>
                    </div>
                </div>
                {selectedOption === "Standard" ? (
                    <div className="container d-flex justify-content-center " style={{ height: "calc(100% - 92px)" }}>
                        <div className="row w-100 h-100  align-content-start " style={{ gap: "8px 0px", overflow: "auto" , padding: " 0px 12px 12px 12px" }}>
                            {filteredTools.filter((tool) =>
                                selectedOption === "Standard" ? !tool.customized : tool.customized
                            ).length === 0 ? (
                                <p className="text-center mb-0 h-100 w-100" >
                                    <div className="no-ucdata-tl h-100 w-100">
                                        <img src={no_ucdata} className="no-image-tl" alt="no_ucdata" />
                                        <span style={{ color: "#e80981" }}>Standard tool card is empty</span>
                                    </div>
                                </p>
                            ) : (
                                filteredTools
                                    .filter((tool) =>
                                        selectedOption === "Standard"
                                            ? !tool.customized
                                            : tool.customized
                                    )
                                    .map((option, index) => (
                                        <div
                                            key={index}
                                            className="col-lg-4 col-6 mt-2 mainrows"
                                        >
                                            <div className="tool-container card w-100 h-100">
                                                <h5 className="tool-overviewtxt w-100 h-100">{option.label}
                                                    <br /><span className="cart-content-tl mt-1" >{option.description}</span>
                                                </h5>
                                            </div>
                                        </div>
                                    ))
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="container d-flex justify-content-center " style={{ height: "calc(100% - 92px)" }}>
                        <div className="row w-100 h-100  align-content-start " style={{ gap: "8px 0px" }}>
                            {filteredCustTools.filter((tool) =>
                                selectedOption === "Customized" ? !tool.customized : tool.customized
                            ).length === 0 ? (
                                <p className="text-center mb-0 h-100 w-100" >
                                    <div className="no-ucdata-tl h-100 w-100">
                                        <img src={no_ucdata} className="no-image-tl" alt="no_ucdata" />
                                        <span style={{ color: "#e80981" }}>Customized tool card is empty</span>
                                    </div>
                                </p>
                            ) : (
                                filteredCustTools
                                    .filter((tool) =>
                                        selectedOption === "Customized"
                                            ? !tool.customized
                                            : tool.customized
                                    )
                                    .map((option, index) => (
                                        <div
                                            key={index}
                                            className="col-lg-4 col-6 mt-2 mainrows"
                                        >
                                            <div className="tool-container card w-100 h-100">
                                                <h5 className="tool-overviewtxt w-100 h-100">{option.label}
                                                    <br /><span className="cart-content-tl mt-1" >{option.description}</span>
                                                </h5>
                                            </div>
                                        </div>
                                    ))
                            )}
                        </div>
                    </div>
                )}
            </div>
            {addtoolopen && (
                <div className='tool-overlay'>
                    <ToastContainer />
                    <div className='tool-content'>
                        <div className='row mt-2 d-flex justify-content-between'>
                            <h5 className='col-8 toolheadtxt'>Add new  {selectedOption === "Customized" ? "customized" : "standard"
                            } tool</h5>
                            <h6 className='col-4 d-flex justify-content-end'>
                                <FontAwesomeIcon className='text-end toolpopupremve' onClick={handelclosetool} icon={faXmark} />
                            </h6>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter tool use case </h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <input type="text" className='form-control' value={formData.label} name="label" required onChange={handleChange} placeholder='Enter tool name' />
                            </div>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter tool description</h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <textarea className="form-control" placeholder='Enter tool description' name="description" required value={formData.description} onChange={handleChange} rows="6" cols="36"></textarea>
                            </div>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter camera resolution</h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <input type="text" className='form-control' name="camera_resolution" value={formData.camera_resolution} required onChange={handleChange} placeholder='Enter camera resolution' />
                            </div>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter system requirement</h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <input type="text" className='form-control' name="system_requirement" value={formData.system_requirement} required onChange={handleChange} placeholder='Enter system requirement' />
                            </div>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter camera Position</h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <input type="text" className='form-control' name="camera_position" value={formData.camera_position} required onChange={handleChange} placeholder='Enter camera Position' />
                            </div>
                            <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter Installation guide</h6> </div>
                            <div className='col-7 mt-2 d-flex align-items-center justify-content-start'>
                                <input type="text" className='form-control' name="installation_guide" value={formData.installation_guide} required onChange={handleChange} placeholder='Enter Installation guide' />
                            </div>
                            {selectedOption === "Customized" && (
                                <div className="col-12 d-flex">
                                    <div className='col-5 mt-2 d-flex align-items-center justify-content-start'><h6 className="mb-0" >Enter code</h6> </div>
                                    <div className='col-7 mt-2 d-flex align-items-center justify-content-start ps-2'>
                                        <input type="text" className='form-control' name="code" value={formData.code} required onChange={handleChange} placeholder='Enter code' />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-3 gap-2">
                            <button type="button" className="Add-savebtn" onClick={() => {
                                if (selectedOption === "Standard") {
                                    handleEditSubmit(formData.id);
                                    handleSubmit();
                                } else {
                                    handleCustSubmit();
                                }
                            }}>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Tools;
